import React, { useEffect, useState } from 'react';
import b_ from 'b_';
import { Layout } from 'antd';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Outlet, useLocation } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import Header from '../Header';
import ErrorBlock from '../ErrorBlock';
import LoadingBlock from '../LoadingBlock';
import {
  coreCompleteNonManagerCustomerInit,
  coreFailNonManagerCustomerInit,
  coreSetCurrentCustomer,
  coreStartNonManagerCustomerInit,
  fetchAccountData,
} from '../../Reducers/core';
import {
  removeCurrentCustomerFromLS,
  resolveCurrentCustomer,
  setCurrentCustomerToLS,
} from '../../Services/CoreService';
import './styles.scss';

const { Content } = Layout;
const b = b_.lock('MainLayout');

function MainLayout() {
  const dispatch = useDispatch();
  const [manager, setManager] = useState(null);

  const token = localStorage.getItem('ni-dash_access_token');
  const nonManagerCustomerInit = useSelector(
    (state) => state.core.nonManagerCustomerInit,
    shallowEqual
  );

  useEffect(() => {
    if (!token) {
      setManager(false);
      return;
    }

    let tokenData;
    try {
      tokenData = jwtDecode(token);
    } catch (error) {
      setManager(false);
      return;
    }

    if (tokenData['cognito:groups']) {
      if (tokenData['cognito:groups']
        .some((group) =>
          group.includes('manager') ||
          group.includes('admin') ||
          group.includes('cargo') ||
          group.includes('manager') ||
          group.includes('support'))) {
        setManager(true);
      } else {
        setManager(false);
      }
    } else {
      setManager(false);
    }
  }, [token]);

  useEffect(() => {
    if (!token || manager !== false) {
      return;
    }

    let isCancelled = false;

    dispatch(coreStartNonManagerCustomerInit());
    removeCurrentCustomerFromLS();
    dispatch(fetchAccountData())
      .then((accountData) => {
        if (isCancelled) {
          return;
        }

        const currentCustomer = resolveCurrentCustomer(accountData);

        if (!currentCustomer) {
          console.error(
            'Invalid /account/details payload for non-manager customer initialization.',
            accountData
          );
          removeCurrentCustomerFromLS();
          dispatch(coreFailNonManagerCustomerInit('Invalid customer payload from /account/details.'));
          return;
        }

        dispatch(coreSetCurrentCustomer(currentCustomer));
        setCurrentCustomerToLS(currentCustomer);
        dispatch(coreCompleteNonManagerCustomerInit());
      })
      .catch((error) => {
        if (isCancelled) {
          return;
        }

        console.error('Failed to initialize non-manager customer from /account/details.', error);
        removeCurrentCustomerFromLS();
        dispatch(coreFailNonManagerCustomerInit(error?.message || error));
      });

    return () => {
      isCancelled = true;
    };
  }, [dispatch, manager, token]);

  const location = useLocation();
  const shouldWaitForRoleResolution = manager === null && !!token;
  const shouldBlockNonManagerContent = manager === false && !nonManagerCustomerInit.isInitialized;

  return (
    <Layout className={b()}>
      <Header location={location} isManager={manager} />
      <Content className={b('content')}>
        {shouldWaitForRoleResolution ? (
          <LoadingBlock loading>
            <div />
          </LoadingBlock>
        ) : shouldBlockNonManagerContent ? (
          nonManagerCustomerInit.error ? (
            <ErrorBlock
              message={nonManagerCustomerInit.error}
              description="Failed to initialize current customer."
            />
          ) : (
            <LoadingBlock loading>
              <div />
            </LoadingBlock>
          )
        ) : (
          <Outlet context={manager} />
        )}
      </Content>
    </Layout>
  );
}

export default MainLayout;
